import { createContext } from 'react'

const HandlingContext = createContext()

export default HandlingContext
